import { Checkbox } from "@components/ui/Checkbox"
import { defineBlock, InspectorControls, useInlineEditableValue } from "eddev/blocks"
import { ReactNode } from "react"

export const meta: BlockMeta = {
  title: "Event Credits List",
  icon: "forms",
  description: "Credits, from Ferve.",
  category: "text",
  tags: ["film-sidebar"],
  conditions: {
    multiple: false,
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-credits", (props) => {
  const [hideCredits, setHideCredits] = useInlineEditableValue<string[]>("hideTypes", [])

  let contents = (
    <div>
      <ul className="flex flex-col gap-4">
        {FILM_CREDITS.map((credit, i) => {
          if (hideCredits.includes(credit.label)) return null
          const value = credit.get(props.film)
          return value ? (
            <li key={i} className="flex flex-col gap-1">
              <div className="type-body-xs uppercase">{credit.label}</div>
              <div className="type-label-l">{value}</div>
            </li>
          ) : null
        })}
      </ul>
    </div>
  )

  if (env.admin) {
    contents = (
      <>
        <InspectorControls>
          <div className="px-4 flex flex-col gap-1">
            {FILM_CREDITS.map((credit, i) => {
              return (
                <Checkbox
                  key={i}
                  label={credit.label}
                  checked={!hideCredits.includes(credit.label)}
                  onCheckedChange={(checked) => {
                    if (checked) {
                      setHideCredits(hideCredits.filter((v) => v !== credit.label))
                    } else {
                      setHideCredits([...hideCredits, credit.label])
                    }
                  }}
                />
              )
            })}
          </div>
        </InspectorControls>
        {contents}
      </>
    )
  }

  return contents
})

type CreditType = {
  label: string
  get: (film: BlockProps["film/film-credits"]["film"]) => ReactNode
}

const FILM_CREDITS: CreditType[] = [
  { label: "Original Title", get: (film) => film?.filmInfo?.originalTitle },
  { label: "Year", get: (film) => film?.filmInfo?.year },
  { label: "Country", get: (film) => film?.filmInfo?.country?.join(", ") },
  { label: "Language", get: (film) => film?.filmInfo?.language },
  { label: "Premiere Status", get: (film) => film?.filmInfo?.premiereStatus },
  { label: "Director", get: (film) => film?.credits?.director?.join(", ") },
  { label: "Producer", get: (film) => film?.credits?.producer },
  { label: "Cast", get: (film) => film?.credits?.cast },
  { label: "Writer", get: (film) => film?.credits?.writer },
  { label: "Cinematographer", get: (film) => film?.credits?.cinematographer },
  { label: "Editor", get: (film) => film?.credits?.editor },
  { label: "Genre", get: (film) => film?.filmInfo?.genre?.join(", ") },
  { label: "Theme", get: (film) => film?.filmInfo?.theme?.join(", ") },
  { label: "Award", get: (film) => film?.filmInfo?.award?.join(", ") },
  { label: "Official Website", get: (film) => film?.filmInfo?.officialWebsite },
  {
    label: "Community Partners",
    get: (film) =>
      film?.communityPartners
        ?.map((p) => p?.title)
        .filter(Boolean)
        .join(", "),
  },
]
